import { faker } from '@faker-js/faker'

const generateMockOptions = (count, _prefix) => {
  return Array.from({ length: count }, () => ({
    label: faker.company.name(),
    value: faker.company.name(),
  }))
}

export const LOCATIONS_MOCK = generateMockOptions(5, 'Location')
export const LOCATION_GROUPS_MOCK = generateMockOptions(3, 'Group')
export const ACESS_POLICIES_OPTIONS_MOCK = generateMockOptions(4, 'Policy')

const generateMockedLocation = () => {
  return {
    node: {
      id: faker.string.uuid(),
      name: `${faker.company.name()} Location`,
      v1Id: faker.number.int(),
    },
  }
}

export const LOCATIONS_MOCKED_RESPONSE = {
  sites: {
    results: Array.from({ length: 50 }, generateMockedLocation),
    pageInfo: {
      startCursor: faker.string.uuid(),
      endCursor: faker.string.uuid(),
      totalRecords: 50,
    },
  },
}

const generateMockedSite = () => ({
  row: {
    siteId: faker.string.uuid(),
    name: `${faker.company.name()} Location`,
    status: 'active',
    createdAt: faker.date.past().toISOString(),
  },
})

export const SITES_MOCKED_RESPONSE = {
  sites: {
    results: Array.from({ length: 50 }, generateMockedSite),
  },
}

export const AVAILABLE_TO_ASSIGN_SITES_MOCKED_RESPONSE = {
  availableToAssignSites: {
    results: Array.from({ length: 50 }, generateMockedLocation),
    pageInfo: {
      startCursor: faker.string.uuid(),
      endCursor: faker.string.uuid(),
      totalRecords: 50,
      hasNextPage: true,
    },
  },
}

export const AVAILABLE_TO_ASSIGN_SITE_GROUPS_MOCKED_RESPONSE = {
  availableToAssignSiteGroups: {
    results: Array.from({ length: 50 }, generateMockedLocation),
    pageInfo: {
      startCursor: faker.string.uuid(),
      endCursor: faker.string.uuid(),
      totalRecords: 50,
      hasNextPage: true,
    },
  },
}

export const AVAILABLE_TO_ASSIGN_REGIONS_MOCKED_RESPONSE = {
  availableToAssignRegions: {
    regionId: faker.string.uuid(),
    regionName: faker.location.city(),
    sites: Array.from({ length: 2 }, generateMockedLocation),
  },
}

export const REGIONS_MOCK_RESPONSE = {
  regions: new Array(50).fill().map(() => ({
    name: faker.location.city(),
    id: faker.string.uuid(),
  })),
}

export const REGIONS_MOCK_OPTIONS = {
  regions: new Array(50).fill().map(() => ({
    id: faker.string.uuid(),
    label: faker.location.city(),
    value: faker.location.city(),
  })),
}
